import { render, staticRenderFns } from "./characters.vue?vue&type=template&id=c61eac86&scoped=true&"
import script from "./characters.vue?vue&type=script&lang=js&"
export * from "./characters.vue?vue&type=script&lang=js&"
import style0 from "./characters.vue?vue&type=style&index=0&id=c61eac86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61eac86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
